import { render, staticRenderFns } from "./Tagnav.vue?vue&type=template&id=9eca298a&scoped=true"
import script from "./Tagnav.vue?vue&type=script&lang=js"
export * from "./Tagnav.vue?vue&type=script&lang=js"
import style0 from "./Tagnav.vue?vue&type=style&index=0&id=9eca298a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eca298a",
  null
  
)

export default component.exports